import { EnumOption } from './enum-option';

export const SponsorType = {
  All: 0,
  Corporate: 1,
  Individual: 2,
}

export const SponsorTypeList: EnumOption[] = [
  { value: SponsorType.All, label: 'All' },
  { value: SponsorType.Corporate, label: 'Corporate' },
  { value: SponsorType.Individual, label: 'Individual' },
];